import { get, post } from '@/api/request'

export function getUserInfo() {
  return get('/api/users')
}

export function register(params) {
  return post('/api/users/register', params)
}

export function login(params) {
  return post('/api/users/login', params)
}